export interface QuoteToolFormState {
  validationRequests?: number;
  disabledNextButton?: boolean;
}

export const initialQuoteToolFormState: QuoteToolFormState = {
  disabledNextButton: true,
  validationRequests: 0,
};
